import React from 'react';

const requirements = [
  { key: 'minLength', label: 'Mínimo 8 caracteres', test: (p) => p.length >= 8 },
  { key: 'upperCase', label: 'Uma letra maiúscula', test: (p) => /[A-Z]/.test(p) },
  { key: 'lowerCase', label: 'Uma letra minúscula', test: (p) => /[a-z]/.test(p) },
  { key: 'number', label: 'Um número', test: (p) => /\d/.test(p) },
  { key: 'special', label: 'Um caractere especial', test: (p) => /[^a-zA-Z0-9]/.test(p) },
];

export default function PasswordStrength({ password = '' }) {
  return (
    <ul style={{ listStyle: 'none', padding: 0, margin: '4px 0', fontSize: 13 }}>
      {requirements.map(({ key, label, test }) => (
        <li key={key} style={{ color: test(password) ? '#2e7d32' : '#999', lineHeight: 1.6 }}>
          {test(password) ? '✓' : '○'} {label}
        </li>
      ))}
    </ul>
  );
}
